export class TransformUnknownKindError extends Error {
  readonly kind: string;

  constructor(kind: string) {
    super(`Unknown transform step kind: ${kind}`);
    this.name = 'TransformUnknownKindError';
    this.kind = kind;
    Object.setPrototypeOf(this, TransformUnknownKindError.prototype);
  }
}
